import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date) {
  if (!date) return '';
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const [year, month, day] = date?.split('-')?.map(Number);
    return format(new Date(year, month - 1, day), 'dd MMMM yyyy');
  }
  return format(new Date(date), 'dd MMMM yyyy');
}

// export function fDate(date) {
//   const [year, month, day] = date?.split('-');
//   return format(new Date(year, month - 1, day), 'dd MMMM yyyy');
// }

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}
